import { motion } from "framer-motion";
import { ClipboardList, MapPin, FileSpreadsheet, HardHat } from "lucide-react";

const steps = [
  {
    icon: ClipboardList,
    title: "Submit your requirement",
    text: "Share your project details through the form, WhatsApp or a quick call.",
  },
  {
    icon: MapPin,
    title: "Site inspection and discussion",
    text: "We visit the site, understand your needs and discuss the possibilities.",
  },
  {
    icon: FileSpreadsheet,
    title: "Scope and estimate preparation",
    text: "You receive a clear, transparent scope of work with an estimate.",
  },
  {
    icon: HardHat,
    title: "Work execution and supervision",
    text: "Skilled teams execute the work under dedicated NC supervision.",
  },
];

export const HowItWorks = () => {
  return (
    <section id="process" className="py-12 sm:py-20">
      <div className="container-nc">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-gold">
            How NC works
          </span>
          <h2 className="mt-3 text-3xl font-bold tracking-tight text-foreground text-balance sm:text-4xl">
            A simple, four-step process
          </h2>
          <p className="mt-4 text-base leading-relaxed text-muted-foreground">
            Clear from the first conversation to the final handover.
          </p>
        </div>

        <div className="relative mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {/* connecting line on desktop */}
          <div className="pointer-events-none absolute left-0 right-0 top-9 hidden h-px bg-border lg:block" aria-hidden="true" />
          {steps.map((step, i) => (
            <motion.div
              key={step.title}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.45, delay: i * 0.1, ease: "easeOut" }}
              className="relative flex h-full flex-col items-start rounded-xl border border-border bg-card p-6 shadow-card"
            >
              <div className="relative z-10 flex h-14 w-14 items-center justify-center rounded-xl bg-gradient-navy text-primary-foreground shadow-sm">
                <step.icon className="h-6 w-6" />
                <span className="absolute -right-2 -top-2 flex h-6 w-6 items-center justify-center rounded-full bg-gold text-xs font-bold text-gold-foreground">
                  {i + 1}
                </span>
              </div>
              <h3 className="mt-5 text-lg font-bold text-foreground">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{step.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
